/**
 * Detect a scrollTop threshold and add body.scrolled css class.
 */
jQuery(function($){
    var threshold = 120; // pixels
    var w = $(window);
    var b = $('body');
    function check() {
        if (w.scrollTop() >= threshold) {
            b.removeClass('scrolled').addClass('scrolled');
        } else {
            b.removeClass('scrolled');
        }
    }
    w.scroll(_.throttle(check, 250));
    check();
});
